import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class PageDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      name: 'location',
      type: 'Schema.Any'
    },
    {
      name: 'location',
      type: 'Schema.Any'
    },
    {
      name: 'routeParams',
      type: 'Schema.Any'
    },
    {
      name: 'searchParams',
      type: 'Schema.Any'
    },
    {
      name: 'urlParams',
      type: 'Schema.Any'
    },
    {
      name: 'setSearchParams',
      parameters: [
        {
          name: 'searchParams',
          type: 'Schema.Object'
        }
      ],
      type: 'Schema.Function'
    },
    {
      name: 'navigate',
      parameters: [
        {
          name: 'to',
          type: 'Schema.String'
        }
      ],
      type: 'Schema.Function'
    },
    {
      name: 'path',
      type: 'Schema.Union',
      types: [
        {
          expect: {
            type: 'Schema.String'
          },
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.String'
        }
      ]
    },
    {
      items: {
        type: 'Schema.Union',
        types: [
          {
            type: 'Schema.Query'
          },
          {
            type: 'Schema.Variable'
          }
        ]
      },
      name: 'resources',
      type: 'Schema.Array'
    },
    {
      items: {
        type: 'Schema.Element'
      },
      name: 'children',
      type: 'Schema.Array'
    },
    {
      items: {
        type: 'Schema.CSSStyleSheet'
      },
      name: 'stylesheets',
      type: 'Schema.Array'
    }
  ]

  override relationTo = 'Schema.Page'
}
